/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solid_Sharp_Scallop_BendInputs */

const fr_solid_sharp_scallop_bend = /** @type {(inputs: Solid_Sharp_Scallop_BendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun programme trouvé`)
};

/**

* @param {Solid_Sharp_Scallop_BendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const solid_sharp_scallop_bend = /** @type {((inputs?: Solid_Sharp_Scallop_BendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solid_Sharp_Scallop_BendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_solid_sharp_scallop_bend(inputs)
});